import { mediaQuery } from '@/styles/media';
import styled from 'styled-components';

const Text = styled.h2`
  font-size: 20px;
  font-weight: bold;
  line-height: calc(20 / 14);

  ${mediaQuery.sp} {
    font-size: 18px;
    line-height: calc(18 / 14);
  }
`;

type Props = {
  children?: React.ReactNode;
};

const SidebarHeading: React.FC<Props> = ({ children }) => (
  <Text>{children}</Text>
);

export default SidebarHeading;
